import { Component } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';

import { PlaylistDialogMessagesEnum } from '../../../../core/enums/toastr-messages/playlist-dialog-messages.enum';
import { PlaylistsService } from '../../../../core/services/http-services/playlists.service';
import { ToastrMessageEnum } from '../../../../core/enums/toastr-messages/toastr-message.enum';
import { LibraryEditItem } from '../../../../core/models/library-edit-item.model';

@Component({
  selector: 'app-modal-confirm-change-playlist-type',
  templateUrl: './modal-confirm-change-playlist-type.component.html',
  styleUrls: ['./modal-confirm-change-playlist-type.component.scss']
})
export class ModalConfirmChangePlaylistTypeComponent {
  playlist: Partial<LibraryEditItem>;
  header = PlaylistDialogMessagesEnum.PlaylistTypeChangingMessage;
  backupMessage = PlaylistDialogMessagesEnum.PlaylistBackUpMessage;

  constructor(
    private readonly playlistService: PlaylistsService,
    private readonly toastrService: ToastrService,
    private readonly dialogRef: MatDialogRef<ModalConfirmChangePlaylistTypeComponent>
  ) {}

  onBackup() {
    this.playlistService.copyPlaylist(this.playlist.Id)
      .pipe(take(1))
      .subscribe(([createdPlaylist, sourcePlaylist]) => {
        this.playlistService.setFeaturesToLauncher(createdPlaylist, sourcePlaylist);

        this.toastrService.success(
          `\'${this.playlist.Title}\' ${ToastrMessageEnum.SuccessfullyDuplicatedTitle}`,
          PlaylistDialogMessagesEnum.PlaylistDuplicationTitle
        );
      });

    this.dialogRef.close(true);
  }
}
